<template>
  <div class="table-state">
    <BaseLoadingBar v-if="stateLoading" />
    <div class="table-state__content">
      <div v-if="stateNoData || stateError" class="table-state__illustration">
        <EmptyStateIllustration aria-hidden="true" />
      </div>
      <p class="table-state__text">{{ stateMessage }}</p>
      <p v-if="stateSubText" class="table-state__subtext">{{ stateSubText }}</p>
      <div v-if="$slots.action" class="table-state__action">
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<script>
import EmptyStateIllustration from '@/assets/images/empty-state-illustration.svg';
import BaseLoadingBar from '@/components/base/BaseLoadingBar';

export default {
  name: 'TableState',
  props: {
    stateText: {
      type: String,
      // Optional. Allows to customize loading and no results messages from parent component.
      // Defaults for loading and no results are provided in the computed property.
    },
    stateSubText: {
      type: String,
      required: false,
      default: '',
    },
    stateLoading: {
      type: Boolean,
      default: false,
    },
    stateNoData: {
      type: Boolean,
      default: false,
    },
    stateError: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseLoadingBar,
    EmptyStateIllustration,
  },
  computed: {
    stateMessage() {
      if (this.stateText) {
        return this.stateText;
      } else if (this.stateLoading) {
        return this.$t('table.state.loading');
      } else if (this.stateNoData) {
        return this.$t('table.state.nodata');
      } else if (this.stateError) {
        return this.$t('table.state.error');
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss">
.table-state {
  background: $color-white;
  display: flex;
  flex: auto;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-radius: $border-radius-root;

  &__content {
    align-items: center;
    display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: center;
    padding: 132px 0;
  }

  &__illustration {
    margin-bottom: 24px;
  }

  &__text {
    color: $color-text-body;
    font-size: 18px;
    font-weight: 500;
    margin: 0 auto;
    max-width: 500px;
    text-align: center;
    padding-bottom: 8px;
  }

  &__subtext {
    color: $color-text-muted;
    font-size: 14px;
    font-weight: 400;
    margin: 0 auto;
    max-width: 420px;
    text-align: center;
    line-height: 1.5;
  }

  &__action {
    margin-top: 24px;
  }
}
</style>
